import {
    useCreateOrderMutation,
    useDeleteOrderMutation,
    useGetOrderMaterialsQuery as useGetOrderMaterialsV2Query,
    useGetOrdersQuery as useGetOrdersV2Query,
    useGetOrdersWithTruckNamesQuery as useGetOrdersWithTruckNamesV2Query,
    useUpdateOrderMutation,
} from '#api/orderApi.slice.ts';
import type { RTKQueryOptions } from '#api-bridge/utils/rktQuery.utils.ts';
import type { OrderType } from '#domain/Order.ts';

export const useDeleteOrder = () => useDeleteOrderMutation();

export const useGetOrdersQuery = (options?: RTKQueryOptions, types?: OrderType[]) =>
    useGetOrdersV2Query(types, options);
export const useGetOrdersWithTruckNamesQuery = (options?: RTKQueryOptions, types?: OrderType[]) =>
    useGetOrdersWithTruckNamesV2Query(types, options);

export const useGetOrderMaterialsQuery = (orderId: string, options?: RTKQueryOptions) =>
    useGetOrderMaterialsV2Query(orderId, options);

export { useCreateOrderMutation, useUpdateOrderMutation };
